import React, { Component } from 'react';

import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Select from './select';
import { translate } from '../../utils/translation-utils';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    root: {
        minWidth: '120px'
    },
    selectedValue: {
        marginTop: 2
    }
} );

class DomainTypeSelector extends Component{
    changeDomainType = ( event ) => {
        const selectedDomainType = event.target.value;

        this.props.handleDomainTypeChange( selectedDomainType );
    }

    render(){
        const { selectedDomainType, classes, automationId } = this.props;
        const opts = [
            { display: translate( 'all-domains' ), key: 'all' },
            { display: translate( 'sending-domains' ), key: 'sending' },
            { display: translate( 'nonsending-domains' ), key: 'nonsending' }
        ];

        return (
            <FormControl className={classes.root} data-automation-id={automationId}>
                <Select
                    value={selectedDomainType}
                    onChange={this.changeDomainType}
                    className="no-print"
                    renderValue={( value ) => <Typography variant="body1" classes={{ root: classes.selectedValue }}>{value}</Typography>}
                >
                    {
                        opts.map( ( option ) => {
                            return <MenuItem key={option.key} value={option.key}>{option.display}</MenuItem>;
                        } )
                    }
                </Select>
            </FormControl>
        );
    }
}

DomainTypeSelector.propTypes = {
    automationId: PropTypes.string,
    classes: PropTypes.object,
    handleDomainTypeChange: PropTypes.func.isRequired,
    selectedDomainType: PropTypes.string.isRequired
};

export default withStyles( styles )( DomainTypeSelector );
